// extracted by mini-css-extract-plugin
module.exports = {"container":"_2O5XiSZCCz0G5wVGut5vFT"};